@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackJoin {
  width: 100%;
  position: relative;
  margin-top: 70px;

  .names {
    display: flex;
    flex-direction: column;
    gap: 25px;
    position: relative;
    z-index: 1;

    .titles {
      h2, h3 {
        font-size: 28px;

        @include texts.font("semi-bold");
      }
    }
  }

  .start {
    margin-top: 30px;
    border-top: 2px solid var(--web-border-blue);
    background: var(--web-grad-blue);
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    height: fit-content;
    cursor: pointer;
    width: fit-content;
    margin-left: auto;
    border-radius: 17px;
    padding: 17px 32px;
    font-size: 15px;

    &:hover {
      background: var(--web-blue-hover);

      .icon {
        transform: translateX(8px);
      }
    }

    .startShadow {
      background: var(--web-blue);
      filter: blur(100px);
      width: 168px;
      height: 168px;
      position: absolute;
      pointer-events: none;
    }

    .content {
      display: flex;
      gap: 15px;
      position: relative;
      align-items: center;

      .icon {
        height: 16px;
        width: 16px;
        filter: var(--icon-white);
        transition: transform 0.1s ease-in-out;

        @include icons.ico("black-right-arrow");
      }
    }
  }

  @media (max-width: 930px) {
    margin-top: 25px !important;

    .start {
      margin-right: auto;
    }

    h2, h3 {
      font-size: 22px !important;
    }
  }
}